<footer class="footer">
    <div class="container text-center">
      <p>&copy; 2025 VoyJaleas. Todos los derechos reservados.</p>
      <a href="https://voyjaleas.com">www.voyjaleas.com</a>
    </div>
</footer>  